export const FEEDBACK_REVIEW_SESSION_KEY = 'feedback-review-dismissed';
export const SYSTEM_MESSAGE_HIDE_KEY = 'system-message-hide';
